module.exports = __webpack_public_path__ + "img/qrcode_image.8295f484.png";